export default "__VITE_ASSET__CsXLxDUW__"